// extracted by css-extract-rspack-plugin
export default {"menuTrigger":"menuTrigger-N6F1D5"};